import React, { Component } from 'react';
import styled from 'styled-components';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    // this.focus = this.focus.bind(this);
  }

  // focus() {
  //   this.refs.input.focus();
  // }
  onChange(e) {
    const targetVal = e.target.value || e.target[e.target.selectedIndex].value;
    this.props.onChange({ target: { value: targetVal } });
  }

  render() {
    const display = !!this.props.value ? 'block' : 'none';
    const marginTop = !!this.props.value ? '20px' : '10px';
    const containerStyle = this.props.style || {};

    return (
      // <Container onClick={() => this.focus()}>
      <Container style={containerStyle}>
        <div
          style={{
            position: 'absolute',
            fontSize: 20,
            color: '#a5b0ba',
            marginTop: 12,
            display: this.props.value === '' ? 'block' : 'none',
            pointerEvents: 'none',
          }}
        >{this.props.placeHolder}</div>
        <label htmlFor={this.props.name} style={{ display }}>{this.props.placeHolder}</label>
        <select
          value={this.props.value}
          onChange={this.onChange}
          // onChange={this.props.onChange}
          style={{
            marginTop: 20,
            border: 'none',
            marginLeft: -8,
            backgroundColor: 'white',
            width: '105%',
            outline: 'none',
          }}
        >
          {this.props.options.map(o => <option>{o}</option>)}
        </select>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 70px;
  border: 2px solid #e5e5e5;
  border-radius: 0.25em;
  padding: 0.7em 1em;

  input {
    width: 425px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    z-index: 1;

    &::placeholder {
      opacity: 1;
      color: #a1aeb7 !important;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #a1aeb7 !important;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/redesign/web/components/LabelledSelect/index.js